import "./NavigationTooltip.css";

import Tooltip from "rc-tooltip";
import { ReactElement } from "react";

interface NavigationTooltipProps {
  text: string;
  children: ReactElement;
  corners?: "default" | "rounded";
}

export const NavigationTooltip = ({ text, children, corners = "default" }: NavigationTooltipProps): JSX.Element => {
  return (
    <Tooltip
      placement="bottom"
      overlayClassName={`NavigationTooltip ${corners}`}
      overlay={<div className={`body4 NavigationTooltipContainer ${corners}`}>{text}</div>}
    >
      {children}
    </Tooltip>
  );
};
